import { Paper } from 'e100-react-components';
import React from 'react';
import { useStyles } from './styles';
import classNames from 'classnames';
import { Title } from './Title/Title';
import { useMediaQuery, useShowPartModalContent } from 'common/hooks';
import { Modal } from 'components';
import useModalClasses from '../hooks/useModalClasses';

import { ReactNode } from 'react';

type ChildrenFn = (props: { showPartContent: boolean; }) => ReactNode;
interface PaperWorkAreaProps {
  children?: ReactNode | ChildrenFn;
  className?: string;
  title?: any;
  left?: number;
  showCloseButton?: boolean;
  onClose?: () => void;
}

export const PaperWorkArea = ({
  children,
  className,
  title,
  left,
  onClose
}: PaperWorkAreaProps) => {
  const { isMobile } = useMediaQuery();
  const [showPartContent, onTogleShowPartContent] = useShowPartModalContent(isMobile);
  const modalClasses = useModalClasses(showPartContent);
  const classes = useStyles({ left, isMobile });

  if (isMobile) {
    return (
      <Modal
        title={title}
        showCloseButton
        disableEnforceFocus
        onClose={() => {
          if (onClose) {
            onClose();
          }
        }}
        fullScreen={isMobile}
        bottomPosition={!showPartContent}
        onClickExpandContent={onTogleShowPartContent}
        showTitleArrow={isMobile}
        dialogContentKey={'Information about station'}
        classes={modalClasses}
      >
        {typeof children === 'function' ? children({ showPartContent }) : children }
      </Modal>
    );
  }

  return (
    <Paper
      classes={{
        root: classNames([classes.root, className]),
      }}
    >
      {title && <Title title={title} onClose={onClose} />}
      {typeof children === 'function' ? children({ showPartContent }) : children }
    </Paper>
  );
};
